angular.module('forms')
.component('formGrid', {
	templateUrl: function(FormsTplDir, FormsFormGridTplUrl) {return FormsFormGridTplUrl || FormsTplDir+'form-grid.html'},
	bindings: {
		object: '=*formObject',
		errors: '<formErrors',
		fields: '<formFields',
		layout: '<formLayout',			    // optional
		compact: '<formCompact',			// optional
		labelClass: '@?formLabelClass',		// optional
		editorClass: '@?formEditorClass',	// optional
		boxClass: '@?formBoxClass',	// optional
		horizontal: '<?gridHorizontal',
		fieldStateNotify: '&?',
	},
	controller: function($scope) {
		var self = this;
		this.items = [];

		this.processLayout = function(layout, isHorizontal, labelClass, editorClass, boxClass, compact, col12) {
			var gridLayout;
			if (typeof layout == 'string') {
				gridLayout = {
					groups: layout,  // string is pane
					col12: col12,
					isHorizontal: isHorizontal,
					type: 'pane',
					editorClass: editorClass,
					labelClass: labelClass,
					boxClass: boxClass,
					compact: compact
				}
			} else if (typeof layout == "object" && typeof layout.length == "number") {
				gridLayout = {
					items: layout.map(function(item) {
						var new_col12 = layout.length? Math.max(1, 0 | (12.0 / layout.length)) : 0;
						return self.processLayout(item, !isHorizontal, labelClass, editorClass, boxClass, compact, new_col12);
					}),  // array is grid
					col12: col12,
					isHorizontal: isHorizontal,
					type: 'grid',
					editorClass: editorClass,
					labelClass: labelClass,
					boxClass: boxClass,
					compact: compact
				}
			} else if (typeof layout == "object" && layout) {
				gridLayout = angular.extend({
					type: layout.groups? 'pane' : 'grid',
					col12: col12,
					isHorizontal: isHorizontal,
					editorClass: editorClass,
					labelClass: labelClass,
					boxClass: boxClass,
					compact: compact
				}, layout);
				if (gridLayout.type == 'grid') {
					gridLayout.items = layout.items.map(function(item) {
						var new_col12 = layout.items.length? Math.max(1, 0 | (12.0 / layout.items.length)) : 0;
						return self.processLayout(item, !gridLayout.isHorizontal, gridLayout.labelClass, gridLayout.editorClass, gridLayout.boxClass, gridLayout.compact, new_col12);
					});
				}
			}
			return gridLayout;
		}

		$scope.$watch(function(){return self.layout}, function(){
			//self.gridLayout.items.length = 0;
			var new_col12 = self.layout.length? Math.max(1, 0 | (12.0 / self.layout.length)) : 0;
			self.gridLayout = self.processLayout(self.layout, self.horizontal, self.labelClass, self.editorClass, self.boxClass, self.compact, new_col12);
		}, true);
		
	},
	controllerAs: '$grid',
})

.component('formPane', {
	templateUrl: function(FormsTplDir, FormsFormPaneTplUrl) {return FormsFormPaneTplUrl || FormsTplDir+'form-pane.html'},
	bindings: {
		object: '=*formObject',
		errors: '<formErrors',
		fields: '<formFields',
		groups: '<formFieldGroups',			// optional
		compact: '<formCompact',			// optional
		labelClass: '@?formLabelClass',		// optional
		editorClass: '@?formEditorClass',	// optional
		boxClass: '@?formBoxClass',	// optional
		fieldStateNotify: '&?',
	},
	controller: function($parse) {
		this.errors = this.errors || {}
	
		this.inGroup = function(groups) {
			if (!this.groups) {
				return true;
			}
			if (typeof groups == "string") groups = [groups];
			var ourgroups = typeof this.groups == "string"? [this.groups] : this.groups;
			return !!_.intersection(ourgroups, groups).length
		}
		
		this.isFieldVisible = function(field) {
			var visible_test = $parse(field.visible);
			var visible = visible_test(this.object);
			var in_group = this.inGroup(field.groups)
			return visible && in_group;
		}
		
		this.isFieldEditable = function(field) {
			var editable_test = $parse(field.editable);
			is_field_editable = editable_test(this.object);
			return is_field_editable;
		}
	},
})

.component('fieldBox', {
	templateUrl: function(FormsTplDir, FormsFieldBoxTplUrl) { return FormsFieldBoxTplUrl || FormsTplDir+'field-box.html' },
	bindings: {
		compact: '<fieldCompact',   // =* shallow watch	
		object: '=*fieldObject',     // < one-way binding, * shallow watch
		errors: '<fieldErrors',
		field: '<field',
		labelClass: '@?fieldLabelClass',
		editorClass: '@?fieldEditorClass',
		boxClass: '@?fieldBoxClass',
		fieldStateNotify: '&?',  // vars: field=$box.field, state='valid'|'invalid'|'busy'|null,  message='The data is being uploaded',  id: $scope.$id
	},
	controller: function($parse, $scope, FormService) {
		var self = this;
		var required_test = typeof this.field.required=="string"? $parse(this.field.required) : function(){return self.field.required};
		this.isFieldRequired = function(field) {
			is_field_required = required_test(this.object);
			return is_field_required;
		}
		this.setFieldState = function(state, message) {
			if (self.fieldStateNotify) {
				self.fieldStateNotify({field:self.field, state:state, message:message, id:$scope.$id});
			}
		}
		this.$onDestroy = function() {
			self.setFieldState(null, null);
		}
		this.setFieldState('valid', null);

		this.activateFieldForm = function(form, formdata) {
			var formdata = angular.copy(self.object)
			return FormService.activateFormModal(form, formdata).then(function(result){
				angular.extend(self.object, result);
			});
		}
	},
	controllerAs: '$box',
})


.component('fieldWidget', {
	template: function(FormsTplDir) {
		return	'<span ng-if="$widget.isFieldVisible() && $widget.isFieldEditable()" ng-include="$widget.field.client.edit_template_url||\''+FormsTplDir+'field-widget-\'+($widget.field.client.widget.toLowerCase()||$widget.field.type.toLowerCase())+\'.html\'"></span>' +
				'<span ng-if="$widget.isFieldVisible() && !$widget.isFieldEditable()" ng-include="$widget.field.client.view_template_url||\''+FormsTplDir+'field-view-\'+($widget.field.client.widget.toLowerCase()||$widget.field.type.toLowerCase())+\'.html\'"></span>' + 
				'<span ng-if="!$widget.isFieldVisible()"><i class="fa fa-eye-slash"></i></span>'
	},
	bindings: {
		compact: '<fieldCompact',   // =* shallow watch	
		object: '=fieldObject',     // < one-way binding, * shallow watch
		errors: '<?fieldErrors',	// optional
		field: '<field',
		visible: '<?fieldVisible',
		editable: '<?fieldEditable',
	},
	//priority: 1,
	controller: function($parse, FormsTplDir, $scope, $q, Classes, CurrentUser) {
		var self = this;
		this.visible = (typeof this.visible === "undefined") ? this.field.visible : this.visible;
		this.editable = (typeof this.editable === "undefined") ? this.field.editable : this.editable;
		var visible_test = typeof this.visible == "string"? $parse(this.visible) : function(){return self.visible};
		var editable_test = typeof this.editable == "string"? $parse(this.editable) : function(){return self.editable};
		
		this.isFieldVisible = function() {
			var visible = visible_test(this.object);
			return visible;
		}
		
		this.isFieldEditable = function() {
			is_field_editable = editable_test(this.object);
			return is_field_editable;
		}

		this.testSubmitOnEnter = function(evt){
			if (this.field.client && this.field.client.submitOnEnter) {
				if(evt.key == "Enter" || angular.equals(evt.which||evt.keyCode,13)) {
					$scope.$emit('submitonenter');
				}
			}
		};

		// recalculate default if necessary
		if (this.field.redefault_on && this.field.redefault_on != 'never') {
			var default_func = $parse(this.field.default);
			var depends_func = $parse(this.field.depends);
			var last_value = self.object[self.field.name];
			var orig_value = last_value;
			$scope.$watch(function(){return depends_func(self.object)}, function(){
				var context = angular.extend({$moment: moment, $user: CurrentUser.instance}, self.object)
				if (self.field.redefault_on == 'depends&always' 
					|| (self.field.redefault_on == 'depends&unedited' && last_value == self.object[self.field.name] && (orig_value == null || orig_value == ""))
				) {
					$q.resolve(default_func(context, Classes)).then(function(value){
						self.object[self.field.name] = value;
						last_value = self.object[self.field.name];
					}).catch(function(e){
						self.errors[self.field.name] = e.data.message || 'Recalculation error';
					})
				}
			}, true)
		}
		
		this.formsTplDir = FormsTplDir
	},
	controllerAs: '$widget',
})

